import React, { useEffect, useRef, useState } from 'react'
import Dropdown from 'react-dropdown' // Assuming you're using 'react-dropdown' package

export default function RanchSelector({
  ranches,
  onRanchDropdownChange,
  selectedRanch,
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)

  // Set up MutationObserver to detect class changes
  useEffect(() => {
    if (dropdownRef.current) {
      const targetNodes = document.getElementsByClassName('Dropdown-root')
      if (targetNodes.length > 0) {
        const targetNode = targetNodes[0]
        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.attributeName === 'class') {
              const classList = mutation.target.classList
              if (classList.contains('is-open')) {
                setIsDropdownOpen(true)
              } else {
                setIsDropdownOpen(false)
              }
            }
          }
        })

        // Start observing the target node for attribute changes (class changes)
        observer.observe(targetNode, { attributes: true })

        // Cleanup the observer when the component unmounts
        return () => {
          observer.disconnect()
        }
      }
    }
  }, [dropdownRef.current])

  return (
    <div
      ref={dropdownRef}
      style={{
        height: isDropdownOpen ? '250px' : '50px', // Dynamic height
        minWidth: '400px',
        transition: 'height 0.3s ease', // Smooth transition
        overflow: 'hidden', // Prevents overflow when the height is small
      }}
    >
      <Dropdown
        options={ranches.map((ranch) => ranch.ranch_name)}
        onChange={(e) => onRanchDropdownChange(e)}
        placeholder="Select your ranch"
        value={selectedRanch.ranch_name}
      />
    </div>
  )
}
